module.exports = __webpack_public_path__ + "img/mug-marshmallows.693300da.svg";